import { render, staticRenderFns } from "./tagcategory.vue?vue&type=template&id=0bc444c8&scoped=true"
import script from "./tagcategory.vue?vue&type=script&lang=js"
export * from "./tagcategory.vue?vue&type=script&lang=js"
import style0 from "./tagcategory.vue?vue&type=style&index=0&id=0bc444c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc444c8",
  null
  
)

export default component.exports